import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, getByAtribute} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class DetalhamentoCPFDiferente extends Component {

    static propTypes = {
    };

    constructor(props) {
        super(props);
    }

    render() {
        const razaoSubstituicaoOptions = createSelectOptions(this.props.controller.motivosSubstituicaoCpf, "id", "nome");
        const solicitacaoEtt = this.props.controller.solicitacaoEtt;
        const novoCpfEditavel = this.props.controller.novoCpfEditavel;
        const desabilitarValidacao = _.get(this.props, "desabilitarValidacao", false);
        const cpfDiferenteInformado = this.props.controller.cpfDiferenteInformado;

        const razaoSubstituicao = getByAtribute(this.props.controller.motivosSubstituicaoCpf, solicitacaoEtt.razaoSubstituicao, "id");

        return (
            <div>
                {this.props.controller.exibeAvisoCpfDiferente ? (
                    <FormGroup>
                        <h4>Alerta: o CPF foi alterado</h4>
                    </FormGroup>
                ) : (
                    <FormGroup check className="checkbox-title">
                        <Label check>
                            <Input type="checkbox" checked={solicitacaoEtt.cpfDiferenteInformado}
                                   onChange={() => this.props.controller.toggleUsarCpfDiferente()} disabled={!novoCpfEditavel}/>{' '}
                            <span>Usar um CPF diferente da indicação</span>
                        </Label>
                    </FormGroup>
                )}
                {solicitacaoEtt.cpfDiferenteInformado &&
                <div>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                {novoCpfEditavel ? (
                                    <div>
                                        <Label>Razão substituição <sup>*</sup></Label>
                                        <Select value={solicitacaoEtt.razaoSubstituicao} options={razaoSubstituicaoOptions}
                                                onChange={(value) => this.props.controller.setRazaoSubstituicaoCPF(value)}
                                                noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                                multi={false} />
                                        {!desabilitarValidacao && <Validacao id="razaoSubstituicao" valor={solicitacaoEtt.razaoSubstituicao} tipo={["isRequired"]}/>}
                                    </div>
                                ) : (
                                    <div>
                                        <Label>Razão substituição</Label>
                                        <Input type="text" value={razaoSubstituicao ? razaoSubstituicao.nome : ""} readOnly />
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    {novoCpfEditavel &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Novo CPF <sup>*</sup></Label>
                                <NumberFormat className="form-control" format="###.###.###-##"
                                              value={solicitacaoEtt.dadosMot.cpf}
                                              onChange={(event, values) => this.props.controller.setMotCpf(values.value)}/>
                                {!desabilitarValidacao && <Validacao id="novoCpf" valor={solicitacaoEtt.dadosMot.cpf} tipo={["isRequired", "isCPF"]}/>}
                            </FormGroup>
                        </Col>
                    </Row>
                    }
                </div>
                }
            </div>
        )
    }
}